import React, { useRef, useEffect } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF, Environment } from '@react-three/drei';
import * as THREE from 'three';

function Model({ mouse }) {
    const { scene } = useGLTF('/assets/cube/cube_sphere.glb');
    const meshRef = useRef();

    useFrame((state, delta) => {
        if (meshRef.current) {
            // Smooth rotation based on mouse position
            // mouse.current.x is between -1 and 1

            // Target rotation
            const targetRotationY = mouse.current.x * Math.PI * 0.5; // +/- 90 degrees
            const targetRotationX = mouse.current.y * Math.PI * 0.2; // +/- 36 degrees

            // Smoothly interpolate current rotation to target
            meshRef.current.rotation.y = THREE.MathUtils.lerp(meshRef.current.rotation.y, targetRotationY, 0.05);
            meshRef.current.rotation.x = THREE.MathUtils.lerp(meshRef.current.rotation.x, targetRotationX, 0.05);
        }
    });

    return <primitive object={scene} ref={meshRef} scale={2} position={[0, -1, 0]} />;
}

const ThreeDFeature = () => {
    const mouse = useRef({ x: 0, y: 0 });

    const handleMouseMove = (event) => {
        // Normalize mouse coordinates to -1 to 1
        mouse.current = {
            x: (event.clientX / window.innerWidth) * 2 - 1,
            y: -(event.clientY / window.innerHeight) * 2 + 1
        };
    };

    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return (
        <div className="threed-feature-container">
            <Canvas camera={{ position: [0, -5, 5], fov: 20 }} gl={{ physicallyCorrectLights: true }}>
                {/* Lumière principale venant du haut à droite */}
                <directionalLight
                    position={[5, 10, 5]} // X = droite, Y = haut, Z = devant
                    intensity={2}          // Intensité forte pour éclairer
                    castShadow             // Active les ombres
                    shadow-mapSize-width={1024}
                    shadow-mapSize-height={1024}
                    shadow-camera-near={0.5}
                    shadow-camera-far={50}
                />

                {/* Lumière ambiante pour adoucir les ombres */}
                <ambientLight intensity={1} />

                {/* Lumière secondaire si besoin */}
                <pointLight position={[-5, -5, 5]} intensity={0.5} />

                <Model mouse={mouse} />

                {/* Environnement clair */}
                <Environment preset="studio" />
            </Canvas>
        </div>
    );
};

export default ThreeDFeature;
